import { render, staticRenderFns } from "./setting-question.vue?vue&type=template&id=09f0cd4e&"
import script from "./setting-question.vue?vue&type=script&lang=js&"
export * from "./setting-question.vue?vue&type=script&lang=js&"
import style0 from "./setting-question.vue?vue&type=style&index=0&id=09f0cd4e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports